import styled from 'styled-components';

export const ProfileBox = styled.div`
    display: flex;
    width: 100%;
    overflow: hidden;
    height: 100%;
    & .ant-tabs-tab-btn {
        font-size: 13px;
    }
    & .ant-card-body {
        padding: 10px;
        margin: 0;
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }
    & .ant-tabs-content-holder {
        overflow-y: scroll;
    }
    & .ant-tabs-tabpane {
        padding: 0px !important;
    }
    & .ant-table-cell {
        padding: 10px;
    }
    & th.ant-table-cell {
        font-size: 12px;
    }
`;

export const ProfileNameBox = styled.div``;